import { Node } from '@tiptap/core';

import { scopeBodyStyleCSS, unscopeCSS } from '~/components/document-editor/editor-css';

export const StyleNode = Node.create({
  name: 'style',

  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,

  addOptions(): { scopeId: string | null } {
    return {
      scopeId: null
    };
  },

  addAttributes() {
    return {
      css: {
        default: ''
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'style',
        getAttrs: (element) => {
          const cssContent = (element as HTMLStyleElement).textContent || '';
          const unscopedCSS = unscopeCSS(cssContent);
          return { css: unscopedCSS };
        }
      }
    ];
  },

  renderHTML({ node }) {
    const cssContent = node.attrs.css || '';

    const element = document.createElement('style');
    element.setAttribute('type', 'text/css');
    element.setAttribute('class', 'editor-style');
    element.textContent = cssContent;

    return element;
  },

  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const dom = document.createElement('style');
      Object.entries(HTMLAttributes).forEach(([key, value]) => {
        if (value != null) {
          dom.setAttribute(key, String(value));
        }
      });

      const scopeId = this.options.scopeId;
      const cssContent = node.attrs.css || '';
      const scopedCSS = scopeId ? scopeBodyStyleCSS(cssContent, scopeId) : cssContent;
      dom.textContent = scopedCSS;

      return {
        dom,
        update: (updatedNode) => {
          if (updatedNode.type !== this.type) {
            return false;
          }

          const newCssContent = updatedNode.attrs.css || '';
          const newScopedCSS = scopeId ? scopeBodyStyleCSS(newCssContent, scopeId) : newCssContent;
          dom.textContent = newScopedCSS;

          return true;
        }
      };
    };
  }
});
